import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'modal-add-reserved-time',
	templateUrl: './modal-add-reserved-time.component.html',
	imports: [
		CommonModule, MatSelectModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, ItemNotificationComponent, FormsModule
	]
})
export class ModalAddReservedTimeComponent implements OnInit {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private dialogRef = inject(MatDialogRef<ModalAddReservedTimeComponent>);
	private data = inject(MAT_DIALOG_DATA);

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.submit = this.submit;
		this.vm.close = this.close;

		this.initialize();
	}
	
	initialize() {
		this.vm.user = this.session.getSession().user;
		this.vm.origins = ['siffi.com', 'minudoc.ee'];
		this.vm.targetOrigin = this.vm.user.origin;
		this.vm.initialized = true;
	}
	
	submit() {
		this.vm.submitted = true;
		
		if (!this.vm.targetOrigin || !this.vm.startTime) return;
		
		var payload: any = {
			scheduledStart: moment(this.vm.startTime),
			origin: this.vm.targetOrigin
		};
		
		this.restService.saveReserveTimeSlotBooking(payload)
			.then((response) => {
				this.vm.processing = false;
				this.dialogRef.close(response);
			})
			.catch((error) => {
				console.log(error);
				this.vm.processing = false;
			});
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}